import { render } from "./AppliedImplants.vue?vue&type=template&id=15d68258&scoped=true"
import script from "./AppliedImplants.vue?vue&type=script&lang=js"
export * from "./AppliedImplants.vue?vue&type=script&lang=js"

import "./AppliedImplants.vue?vue&type=style&index=0&id=15d68258&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15d68258"]])

export default __exports__